module.exports = __webpack_public_path__ + "img/Unitychan2.c7dbd055.png";